import { useGetViewupPlusSnsAccounts } from 'Shared/hooks/api';
import { Analytics } from 'Shared/utils/client';
import { LINK } from '@constants';
import { useGlobalModalStore } from 'app/_hook';
import { useRouter } from 'next/navigation';
import { AccountMenuButton } from '../OffViewingButton';

export const ViewpleSettingButton = () => {
  const router = useRouter();

  const { data: getViewpleAccounts } = useGetViewupPlusSnsAccounts();
  const hasViewpleAccounts = (getViewpleAccounts?.data.length || 0) > 0;

  const { getValue } = useGlobalModalStore();
  const { setAlertModal } = getValue('actions');

  const handleClickThis = () => {
    Analytics.getInstance().track('VIEWING_OFF_MENU', { type: 'plus' });
    if (hasViewpleAccounts) {
      router.push(LINK.ACCOUNT_SETTINGS_PLUS);
      return;
    }

    setAlertModal({
      actionButtonText: '계정 추가하기',
      content: `보너스뷰업으로 설정할 수 있는\n계정이 없어요.`,
      onClickActionButton: () => {
        router.push(`${LINK.ACCOUNT_ADD}?platform=instagram&type=plus`);
      },
      title: '계정을 추가해 주세요.',
    });
  };

  return (
    <AccountMenuButton
      content={`추가 포인트가 필요하신가요?`}
      onClick={handleClickThis}
      title={'뷰플 보너스 활동'}
    />
  );
};
